// extracted by mini-css-extract-plugin
module.exports = {"notfound":"DefaultNotFound_notfound__3Yqjw"};